/**
 * Shared formatter + types for email attachment chips.
 *
 * Two surfaces render attachment chips today:
 *   - ``InboxDetailPane.tsx`` reply composer (apps/client)
 *   - ``ActionFieldEditor.tsx`` ``FileListRenderer`` (@ando/ui)
 *
 * Both had a private ``formatAttachmentSize`` / ``formatChipSize`` copy
 * with identical thresholds. Centralising the helper here means a
 * future tweak (e.g. switching to ``Intl.NumberFormat``) ripples once.
 *
 * The chip render itself is still duplicated across the two consumers
 * because their host frames (popover vs textarea adjunct) need slightly
 * different paddings. A future refactor can extract a shared
 * ``<AttachmentChip>`` primitive when the props matrix stabilises.
 */

/**
 * Human-readable size label (B / KB / MB). Chosen to match the chip
 * width budget on both surfaces (~80px max) so the byte count never
 * pushes the filename into truncation.
 */
export function formatAttachmentSize(bytes: number | undefined): string {
  if (bytes === undefined || bytes < 0) return "";
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(0)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}
